// import React from "react";
// import Sidebar from "../../components/Super Admin/SideBar/Sidebar";
// import Topbar from "../../components/Super Admin/TopBar/TopbarLeadManagement";
// import NotificationTemplateList from "../../components/Super Admin/Lead Management/NotificationTempletList";
// // import "./../styles/notificationTemplate.css";

// const NotificationTemplatePage: React.FC = () => {
//   return (
//     <>
//         <Topbar />
//         <NotificationTemplateList />
//     </>
//   );
// };

// export default NotificationTemplatePage;





import React from "react";
import NotificationManagement from "../../components/Super Admin/Lead Management";

// Keeps existing bookmarks working while the old static template page is removed.
const NotificationTemplatePage: React.FC = () => <NotificationManagement />;

export default NotificationTemplatePage;
